<template>
  <div id="content">
    <v-card>
      <v-responsive max-height="500">
        <v-img
          :src="eventCover(event)"
          :lazy-src="require('@/assets/image-not-available-3.jpg')"
          max-height="500"
          gradient="to top, rgba(255,255,255,0), rgba(200,200,200,.15), rgba(25,25,25,.7)"
        ></v-img>
      </v-responsive>
    </v-card>

    <v-container grid-list-lg>
      <v-layout row wrap>
        <v-flex d-flex xs12 sm12 md7 lg8>
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="display-1">{{ event.title }}</h3>
                <h4 class="secondary--text">{{ event.subtitle }}</h4>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <h3 class="section-title mb-3">Overview</h3>
              <p class="subheading" v-if="!event.description">No description.</p>
              <p class="subheading" v-else v-html="event.description"></p>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md5 lg4>
          <v-card>
            <v-list two-line subheader>
              <v-subheader>
                <h4 class="section-title">Schedule</h4>
              </v-subheader>
              <v-list-tile>
                <v-list-tile-action v-show="$vuetify.breakpoint.smAndUp">
                  <v-icon color="black">access_time</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ eventDate(event.startDate, event.endDate) }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ eventTime(event.startDate, event.endDate) }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-action v-show="$vuetify.breakpoint.smAndUp">
                  <v-icon color="red">place</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ event.place }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ event.address }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-divider></v-divider>

            <v-list subheader>
              <v-subheader>
                <h4 class="section-title">Details</h4>
              </v-subheader>
              <v-list-tile v-for="(detail, i) in event.details" :key="i">
                <v-list-tile-content>{{ detail }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile class="subheading" v-if="event.details.length == 0">
                <v-list-tile-content>No details.</v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md12 order-md-1 lg12>
          <v-card flat>
            <v-container grid-list-sm fluid>
              <h3 class="subheading mb-3">Photos</h3>
              <v-layout v-if="event.photos.length !== 0" row wrap>
                <v-flex v-for="(photo, i) in event.photos" :key="i" xs6 sm4 md3 lg2 d-flex>
                  <v-card flat tile class="d-flex">
                    <v-img
                      :src="eventPhotos(photo)"
                      :lazy-src="require('@/assets/image-not-available-3.jpg')"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <!-- <template v-slot:placeholder>
                        <v-layout fill-height align-center justify-center ma-0>
                          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                        </v-layout>
                      </template>-->
                    </v-img>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout v-else>
                <v-flex height="300" text-xs-center>
                  <v-icon x-large>cloud_off</v-icon>
                  <h4 class="display-1 my-2">No Available Photos.</h4>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ImageMixin from "@/mixins/imageMixin";
import AuthenticationService from "@/services/AuthenticationService";
export default {
  data() {
    return {
      event: {
        title: "",
        subtitle: "",
        place: "",
        address: "",
        description: "",
        startDate: "",
        endDate: "",
        details: [],
        cover: "",
        photos: []
      },
      folder: ""
    };
  },
  mounted() {
    this.getEvent();
  },
  methods: {
    async getEvent() {
      let eventId = this.$route.params.event_id;
      const response = await AuthenticationService.getEvent(eventId);
      this.event = response.data;
      this.getEventFolder();
    },
    getEventFolder() {
      let d = new Date(this.event.startDate);
      let yy = ("" + d.getUTCFullYear()).substring(2);
      let mm = ("0" + (d.getUTCMonth() + 1)).slice(-2);
      let dd = ("0" + d.getUTCDate()).slice(-2);
      this.folder = yy + mm + dd;
    }
  },
  computed: {
    eventCover() {
      return event => `${this.baseUrl}/events/${this.folder}/${event.cover}`;
    },
    eventPhotos() {
      return photo => `${this.baseUrl}/events/${this.folder}/photos/${photo}`;
    }
  },
  mixins: [ImageMixin]
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Event.vue